import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { Field, reduxForm } from "redux-form";

import { TextInput } from "../../../../../common/form";

import validationUtils from "../../../../../../utils/ValidationUtils";
import { FOLLOW_UP_COMMENTS_VALIDATION_RULES } from "./followUpCommentsValidationRules";

class FollowUpCommentsCreate extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.create = this.create.bind(this);
  }

  create(data) {
    const { addComment, initialize } = this.props;
    return addComment(data).then(() => initialize({}));
  }

  render() {
    const { readOnly } = this.props;

    return (
      <form
        className="follow-up-comment-form"
        onSubmit={this.props.handleSubmit(this.create)}
      >
        <div className="row">
          <h5>
            <FormattedMessage id="members.followUps.form.comments.commentLabel" />
          </h5>
        </div>
        <div className="row">
          <Field
            id="comment"
            name="comment"
            groupClassName="follow-up-comment-field"
            component={TextInput}
            disabled={readOnly}
            type="textarea"
            componentClass="textarea"
          />
            <div className="button">
              <button disabled={readOnly} type="submit" className="btn btn-lg btn-primary">
              <FormattedMessage id="members.followUps.form.comments.commentSubmit" />
              </button>
            </div>

        </div>
      </form>
    );
  }
}

FollowUpCommentsCreate.propTypes = {
  addComment: PropTypes.func,
  initialize: PropTypes.func,
  handleSubmit: PropTypes.func,
  readOnly: PropTypes.bool
};

export default reduxForm({
  form: "createComment",
  validate: (values) =>
    validationUtils.validate(values, FOLLOW_UP_COMMENTS_VALIDATION_RULES),
})(FollowUpCommentsCreate);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/comments/FollowUpCommentsCreate.js